import { Link } from "react-router-dom";

import withLayoutSimple from "../../components/withLayoutSimple/withLayoutSimple";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageKidC.module.scss";

function PageKidC() {
  const getImgSet = useImgSet();

  const content = getImgSet("content__p05", "png", s.content);

  const back = getImgSet("back__p22", "png");

  return (
    <div className={s.root}>
      <div className={s.inner}>
        {content}
        <Link to="/kid/b" className={s.back}>
          {back}
        </Link>
      </div>
    </div>
  );
}

export default withLayoutSimple(PageKidC, false);
